import type { ActionContext } from 'vuex'

import type { ActionClass, MessagesState } from '../../../models'

import { MESSAGES_CONSTS } from '../../../store/messages/messages.consts'

export class SetLocaleAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<MessagesState, any>, locale: string): void {
    commit(MESSAGES_CONSTS.mutations.setLocale, locale)
  }
}
